import { forwardRef } from "react";
import { ICONSAX_SIZE } from "../Iconsax/Iconsax.types.js";
import { Text } from "../Text/Text.js";
import { TextSize, TextWeight } from "../Text/Text.types.js";
import { StyledTag } from "./Tag.style.js";
import { DefaultTagProps, TagProps } from "./Tag.types.js";

const defaultProps: DefaultTagProps = {
    color: "primary",
};

/**
 * @deprecated This component should not be used directly.
 * Use {@link TagV2} instead which provides the complete tag functionality.
 * This component will be removed in a future version.
 */
export const Tag = forwardRef<HTMLDivElement, TagProps>((props, ref): JSX.Element => {
    const { children, iconLeft: IconLeft, iconRight: IconRight, onIconLeftClick, onIconRightClick, textSize, textWeight } = props;
    const attributes = { ...defaultProps, ...props };

    return (
        <StyledTag ref={ref} {...attributes}>
            {IconLeft && (
                <span onClick={onIconLeftClick} style={{ cursor: onIconLeftClick ? "pointer" : "inherit" }}>
                    <IconLeft size={ICONSAX_SIZE.SMALL} />
                </span>
            )}
            {typeof children === "string" ? (
                <Text size={textSize || TextSize["X-SMALL"]} weight={textWeight || TextWeight.NORMAL}>
                    {children}
                </Text>
            ) : (
                children
            )}
            {IconRight && (
                <span onClick={onIconRightClick} style={{ cursor: onIconRightClick ? "pointer" : "inherit" }}>
                    <IconRight size={ICONSAX_SIZE.SMALL} />
                </span>
            )}
        </StyledTag>
    );
});
